import { render, staticRenderFns } from "./gRNAShow2.vue?vue&type=template&id=e0d2a51c&scoped=true"
import script from "./gRNAShow2.vue?vue&type=script&lang=js"
export * from "./gRNAShow2.vue?vue&type=script&lang=js"
import style0 from "./gRNAShow2.vue?vue&type=style&index=0&id=e0d2a51c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d2a51c",
  null
  
)

export default component.exports